"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BenefitsLayout = void 0;
var _utils = require("../../utils");
var _SixBenefits = require("./SixBenefits");
var _ThreeBenefits = require("./ThreeBenefits");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const BenefitsLayout = (param)=>{
    let { className, data, debug, modulePosition, renderOnMyPages } = param;
    const { title, benefits } = data;
    if (!benefits || benefits.length !== 3 && benefits.length !== 6) {
        return (0, _utils.getModulesContentError)({
            debug,
            modulePosition,
            layout: _constants.BENEFITS_LAYOUT_NAME
        });
    }
    if (benefits.length === 3) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ThreeBenefits.ThreeBenefits, {
            title: title,
            benefits: benefits,
            className: className
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SixBenefits.SixBenefits, {
        renderOnMyPages: renderOnMyPages,
        title: title,
        benefits: benefits,
        className: className
    });
};
exports.BenefitsLayout = BenefitsLayout;
